import { render, staticRenderFns } from "./MyExamResults.vue?vue&type=template&id=5fbf6a3a&scoped=true&"
import script from "./MyExamResults.vue?vue&type=script&lang=js&"
export * from "./MyExamResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbf6a3a",
  null
  
)

export default component.exports